<template>
    <div id="owner-panel">
        <div class="owner-panel-container">
            <div v-if="!pageLoad" class="page-spinner">
                <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
                <span v-if="organization == null">{{translate('own_anyConnectedPlace')}}</span>
            </div>
            <div>
                <div class="owner-panel">
                    <div class="owner-header">
                        <div class="logo">
                            <img src="@/assets/landing/logo.svg" alt="AirVote Logo">
                        </div>
                        <div class="nav">
                            <div class="profile-photo">
                                <div v-if="userInfo.is_verified == false">
                                    <div class="email-confirm__wrapper">
                                        <div class="email-confirm__content">
                                            <div class="email-confirm__icon">
                                                <img src="@/assets/icons/ic_exclamation.svg">
                                            </div>
                                            <div class="email-confirm__text">{{translate('own_email_Confim')}}</div>
                                        </div>
                                        <router-link :to="{name: 'ProfileSettings'}">
                                            <img v-if="userInfo.photo_url" :src="userInfo.photo_url" alt="Profile photo">
                                            <img v-else src="@/assets/profile.jpg" alt="Profile photo">
                                        </router-link>
                                    </div>
                                </div>
                                <div v-else>
                                    <router-link :to="{name: 'ProfileSettings'}">
                                        <img v-if="userInfo.photo_url" :src="userInfo.photo_url" alt="Profile photo">
                                        <img v-else src="@/assets/profile.jpg" alt="Profile photo">
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <router-view></router-view>
            </div>
            <div class="wrapper__404">
                <div class="number__404">4</div>
                <div class="icon__404">
                    <img src="@/assets/icons/404_smile.svg">
                </div>
                <div class="number__404">4</div>
            </div>
            <div class="content__404">
                <div class="title__404">
                    {{translate('title_404')}}
                </div>
                <div class="btn__404" @click="back">
                    {{translate('btn_404')}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import MenuBar from '@/components/widgets/menuBar';
    import config from '@/api/config';
    import errorMixin from '@/mixins/errorMixin';

    export default {
        mixin: [errorMixin, mixin],
        data() {
            return {
                pageLoad: true
            }
        },

        components: {
            MenuBar
        },

        methods: {
            back() {
                this.$router.go(-1);
            },
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            })

        }
    }
</script>

<style>
    #app {
        overflow: hidden;
        display: block;
    }
    .wrapper__404 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 100px;
    }
    .number__404 {
        font-family: Nunito;
        font-style: normal;
        font-weight: 700;
        font-size: 96px;
        line-height: 24px;
        color: #2F2F2F;
    }
    .content__404 {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
    }
    .title__404 {
        width: 227px;
        font-family: Nunito;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #2F2F2F;
    }
    .btn__404 {
         margin-top: 34px;
         background: #3F405C;
         border-radius: 6px;
         padding: 12px 16px;
         font-family: Nunito;
         font-style: normal;
         font-weight: bold;
         font-size: 16px;
         line-height: 24px;
         color: #ffffff;
     }
    .btn__404:hover {
        cursor: pointer;
        color: #ffffff;
    }




    @keyframes zip-amin {
        0% {
            transform: rotate(10deg);
        }
        12% {
            transform: rotate(-10deg);
        }
        20% {
            transform: rotate(10deg);
        }
        60% {
            transform: rotate(370deg);
        }
        70% {
            transform: rotate(350deg);
        }
        76% {
            transform: rotate(345deg);
        }
        100% {
            transform: rotate(360deg);
        }

    }

    @keyframes space-man {
        0% {
            top: -20vh;
            right: -100vw;
        }
        100% {
            top: 10vh;
            right: 0vw;
        }
    }
</style>